export function createSearchTermsAutoSelectionController({
  getState,
  setState,
  getSelectionMode,
  normalizeSearchTermsDraft,
  getLocalCandidates,
  buildAutoSelection,
} = {}) {
  let inFlight = null;
  let selectedBatchId = '';

  function hasSelection() {
    const selected = getState('selectedStKeywords');
    return selected instanceof Set ? selected.size > 0 : Array.isArray(selected) && selected.length > 0;
  }

  function shouldAutoSelect() {
    const jobId = getState('batchJobId');
    if (!jobId || getState('currentStep') !== 2) return false;
    if (getSelectionMode() !== 'ai') return false;
    if (selectedBatchId === jobId || hasSelection()) return false;
    const draft = normalizeSearchTermsDraft(getState('step02SearchTermsSelectionDraft') || {});
    return !draft.searchTermsEn && draft.candidates.length === 0;
  }

  async function autoSelect({ force = false } = {}) {
    const jobId = getState('batchJobId');
    if (!jobId) return null;
    if (inFlight) return inFlight;
    if (!force && !shouldAutoSelect()) return null;

    selectedBatchId = jobId;
    inFlight = (async () => {
      try {
        const candidates = getLocalCandidates();
        if (!candidates.length) {
          selectedBatchId = '';
          return [];
        }
        const selection = buildAutoSelection({
          candidateKeywords: candidates,
          keywordUsePolicies: getState('keywordUsePolicies') || [],
          autoSelectionReview: getState('businessContext')?.keywordAutoSelectionReview || null,
        });
        if (selection.selected.length > 0) setState('selectedStKeywords', new Set(selection.selected));
        setState('stSelectionMode', 'ai');
        return selection.selected;
      } finally {
        inFlight = null;
      }
    })();

    try {
      return await inFlight;
    } catch (error) {
      selectedBatchId = '';
      throw error;
    } finally {
      inFlight = null;
    }
  }

  function reset() {
    selectedBatchId = '';
  }

  return { autoSelect, hasSelection, reset };
}
